export const primary400 = '#ed1d27';
export const yellow400 = '#facc15';
export const green400 = '#4ade80';
